import { AfterConference } from 'domain/usecases/conference/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteAfterConference implements AfterConference {
  private readonly url: string;

  private readonly httpClient: HttpClient<AfterConference.Model>;

  constructor(url: string, httClient: HttpClient<AfterConference.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  get = async (
    params: AfterConference.Params,
  ): Promise<AfterConference.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{short}', `${params.short}`),
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
      case HttpStatusCode.notModified:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
